module.exports = __webpack_public_path__ + "static/media/20ECE6.dc1c9c18.jpg";